const updateCartSlider = (json, wrapper, slider, slideIndex, swiperClass, slideCardClass, isGift) => {
  if (json.length > 0 && wrapper.classList.contains('hidden')) {
    wrapper.classList.remove('hidden');
  } else if (json.length <= 0 && !wrapper.classList.contains('hidden')) {
    wrapper.classList.add('hidden');
  }

  const noImage = wrapper.dataset.noimage;

  if (slider) {
    slider.removeAllSlides();
  } else {
    slider = new Swiper(`.${swiperClass}`, options);
  }

  const prepareSlideItem = (recommendation, index, promotionName) => {
    let recommendationCardImageSrc;
    let recommendationCardTitleText;
    let recommendationCardType;

    if (
      recommendation.image &&
      recommendation.type == 'pizza' &&
      recommendation.parent &&
      recommendation.parent.image
    ) {
      recommendationCardImageSrc = recommendation.parent.image;
    } else if (recommendation.image) {
      recommendationCardImageSrc = recommendation.image;
    } else if (
      !recommendation.image &&
      recommendation.parent &&
      recommendation.parent.image
    ) {
      recommendationCardImageSrc = recommendation.parent.image;
    } else {
      recommendationCardImageSrc = noImage;
    }

    if (recommendation.parent && recommendation.parent.name) {
      recommendationCardTitleText = recommendation.parent.name;
    } else {
      recommendationCardTitleText = recommendation.name;
    }

    if (recommendation.parent) {
      recommendationCardType = `<div class="type italic very-small-text">${recommendation.name}</div>`;
    }

    const giftTemplate = `
    <div class='cart-slider-card-gift'>
      подарок
    </div>

    <div class='cart-slider-card-additional-info'>
      ${promotionName}
    </div>
`

    const priceTemplate = isGift ? '' : `<div class="price bold very-small-text"> ${recommendation.price / 100} ₽</div>`

    const slide = `<div class="swiper-slide" data-index="${index + 1}">
        <div class="cart-slider-card ${slideCardClass} ${isGift && 'cart-slider-card-with-additional-info'}" data-id=${recommendation.id}>
        ${ isGift ? giftTemplate : ''}
          <div class="image-wrapper">
            <img class="cart-slider-card-image" src=${recommendationCardImageSrc} alt=${
      recommendation.name
    } />
          </div>
          <div class="cart-slider-card-info">
            <div class="cart-slider-card-title very-small-text bold">${recommendationCardTitleText}</div>
            <div class="cart-slider-card-price-wrapper row">
              ${recommendation.parent ? recommendationCardType : ''}
              ${priceTemplate}
            </div>
            <button type="button" class="control-button very-small-text medium add-button">
              <span>Добавить</span>
            </button>
          </div>
        </div>
      </div>`;

    if (slider) {
      slider.appendSlide(slide);
    }
  }

  if (!isGift) {
    json.forEach(prepareSlideItem);
  } else {
    json.forEach(giftsGroup => {
      giftsGroup?.products?.forEach((item, index) => prepareSlideItem(item, index, giftsGroup.promotionName))
    });
  }

  if (slider) {
    slider.update();
    if (slideIndex) {
      slider.slideTo(slideIndex - 1, false, false);
    }
  }
};

export default updateCartSlider;
